export default __webpack_public_path__ + "static/terrible-de5366b10eabed7b99f769978b7957d3.png";